import { render } from "./ImportacionAsistente.vue?vue&type=template&id=f28ef3f2&scoped=true"
import script from "./ImportacionAsistente.vue?vue&type=script&lang=js"
export * from "./ImportacionAsistente.vue?vue&type=script&lang=js"

import "./ImportacionAsistente.vue?vue&type=style&index=0&id=f28ef3f2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f28ef3f2"]])

export default __exports__